<template>
    <div class="video-grid-wrapper">
        <div class="video-grid-main">
            <iframe src="" frameborder="0" class="responsive-iframe js-main-video"></iframe>
        </div>
        <div class="video-grid-categories">
            <a href="#" class="js-video-category" v-bind:data-category="category.Name" v-for="(category, index) in videoCategories" v-on:click="filterByCategory(category.name, $event)">{{ category.displayName }}</a>
        </div>
        <div class="video-grid-items">
            <div class="video-grid-item" v-for="(video, index) in filteredVideos" v-on:click="viewVideo(video.vimeoId, $event)">
                <img v-bind:src="video.thumbnail" v-bind:alt="video.thumbnailAlt" v-bind:data-video-src="'https://player.vimeo.com/video/' + video.vimeoId">
            </div>
        </div>
        <div class="video-grid-more" v-on:click="viewMore">View More</div>
    </div>
</template>


<script>
    export default {
        data() {
            return {
                filteredVideos: [],
                originalFilteredVideos: [],
                selectedCategory: '',
                videoCategories: window.CFCU.VideoCategories,
                videos: window.CFCU.Videos
            }
        },
        mounted() {
            this.filteredVideos = this.videos.slice(0, 4);
            this.originalFilteredVideos = this.videos;

            this.setMainVideo(this.filteredVideos[0].vimeoId);
        },
        methods: {
            filterByCategory(category, event) {
                event.preventDefault();

                this.selectedCategory = category;
                this.originalFilteredVideos = this.videos.filter(video => video.categories.some(c => c.name === category));
                this.filteredVideos = this.originalFilteredVideos.slice(0, 4);

                this.setViewMoreBtn();
            },
            setMainVideo(vimeoId) {
                let mainVideo = document.querySelector('.js-main-video');
                mainVideo.setAttribute('src', `https://player.vimeo.com/video/${vimeoId}`);
            },
            setViewMoreBtn() {
                let viewMoreBtn = document.querySelector('.video-grid-more');

                if (this.filteredVideos.length <= 3 || this.filteredVideos.length === this.originalFilteredVideos.length) {
                    viewMoreBtn.style.display = "none";
                }
                else {
                    viewMoreBtn.style.display = "inline-block";
                }
            },
            viewMore() {
                if (this.selectedCategory !== '') {
                    this.filteredVideos = this.originalFilteredVideos.slice(0, this.filteredVideos.length + 4);
                }
                else {
                    this.filteredVideos = this.videos.slice(0, this.filteredVideos.length + 4);
                }

                this.setViewMoreBtn();
            },
            viewVideo(vimeoId) {
                this.setMainVideo(vimeoId);
            }
        }
    }
</script>